/** Available Telegram Bot modes */
export enum TelegramBotModeEnum {
  /** Polling mode */
  POLLING = 'POLLING',
  /** Webhook mode */
  WEBHOOK = 'WEBHOOK',
}
